import * as styles from './MetaLink.css.ts';
import { Box, Link } from 'braid-design-system';

export interface MetaLinkProps {
  name: string;
  isSplitView: boolean;
  isChild?: boolean;
  href?: string;
  target?: string;
  title?: string;
  type:
    | 'company'
    | 'suburb'
    | 'location'
    | 'area'
    | 'classification'
    | 'subClassification';
  disabledLink?: boolean;
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const MetaLink = (props: MetaLinkProps) => {
  const {
    href = '',
    title,
    name,
    type,
    disabledLink = false,
    isChild = false,
    rel,
    isSplitView,
    onClick,
  } = props;

  const shouldAddUnderline = isSplitView && !disabledLink;

  if (title) {
    return (
      <Link
        className={[
          styles.root,
          { [styles.disabledLink]: disabledLink },
          { [styles.linkUnderline]: shouldAddUnderline },
        ]}
        tabIndex={disabledLink ? -1 : undefined}
        href={href}
        rel={rel}
        title={title}
        aria-label={title}
        data-type={type}
        data-automation={`job${type.charAt(0).toUpperCase()}${type.slice(1)}`}
        onClick={onClick}
      >
        {(isChild && `(${name})`) || name}
      </Link>
    );
  } else if (name) {
    return <Box component="span">{name}</Box>;
  }

  return null;
};

export default MetaLink;
